import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=3904fa24"
import script from "./Finished.vue?vue&type=script&lang=js"
export * from "./Finished.vue?vue&type=script&lang=js"
import style0 from "./Finished.vue?vue&type=style&index=0&id=3904fa24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports